// Stub for downshift, pulled in by @cmpsr Autocomplete components we never use.
export const useCombobox = () => ({});
export const useMultipleSelection = () => ({});

const exports: Record<string, unknown> = { useCombobox, useMultipleSelection };

const handler: ProxyHandler<Record<string, unknown>> = {
  get(target, prop) {
    if (import.meta.env.DEV && typeof prop === 'string' && prop !== '__esModule' && !(prop in target)) {
      console.error(`[shim] Attempted to use un-shimmed export "${prop}" from "downshift". Add it to src/shims/downshift-shim.ts.`);
    }
    return target[prop as string];
  },
};

export default new Proxy(exports, handler);
